import database_en from './database_en.json';

export default database_en;